"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaRetPag = exports.yupRetPag = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupRetPag = yup.object({
    pagId: yup.number().notRequired().integer().nullable().default(0).label('PagId'),
    token: yup.string().max(255).nullable().default('').label('Token'),
    valor: yup.number().min(0).default(0).label('Valor'),
    cobValor: yup.number().min(0).required().default(0).label('Valor da cobrança'),
    cobCodigo: yup.number().integer().min(0).required().default(0).label('Código da cobrança'),
    cobVencimento: yup.string().required().nullable().default('').label('Vencimento da cobrança'),
    vencKey: yup.number().integer().min(0).required().default(0).label('Chave vencimento'),
    cobRef: yup.string().required().max(255).nullable().default('').label('Referência da cobrança'),
    cartaoId: yup.string().max(15).nullable().default('').label('ID do cartão'),
    data: yup.string().nullable().default('').label('Data da cobrança'),
    dataKey: yup.number().nullable().integer().default(0).label('Chave data'),
    taxa: yup.number().positive().min(0).required().default(0).label('Taxa'),
    status: yup.string().max(15).nullable().default('').label('Status da cobrança'),
    tipo: yup.string().max(12).nullable().default('').label('Tipo da cobrança'),
    link: yup.string().max(1024).required().default('').label('Link da cobrança'),
    nome: yup.string().max(65).required().default('').label('Nome'),
    cpf: yup.string().max(15).required().default('').label('CPF'),
    descontoBoleto: yup.number().integer().min(0).max(100).nullable().default(0).label('Desconto'),
    nParCartao: yup
        .number()
        .integer()
        .min(0)
        .max(12)
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .default(null)
        .label('Nº Parcelas'),
    chargeId: yup.string().required().max(255).nullable().default('').label('chargeId'),
    eventId: yup.string().notRequired().max(255).nullable().default(null).label('eventId'),
    entityId: yup.string().notRequired().max(255).nullable().default(null).label('entityId'),
    uidOn: yup.number().nullable().integer().default(null).label('Mensal_On'),
    fintech: yup.mixed().label('Fintech').nullable().default(enums_1.EFintechNamed.JUNO),
    tId: yup.string().notRequired().max(255).nullable().default('').label('tId'),
    fileChargeEnv: yup.string().notRequired().nullable().default('').label('Arquivo de envio de cobrança'),
    fileChargeRet: yup.string().notRequired().nullable().default('').label('Arquivo de retorno cobrança'),
});
exports.schemaRetPag = exports.yupRetPag.shape({});
